import { SLR_BOOKING_DETAILS, SLR_BOOKING_RESULT } from '../constants'

const initState = {
	slrBookingDetails: null,
	slrError: null,
	resultData: null,
}

export default function (state = initState, action) {
	switch (action.type) {
		case SLR_BOOKING_DETAILS.SUCCESS:
			return {
				...state,
				slrBookingDetails: action.response,
				slrError: null,
			}
		case SLR_BOOKING_DETAILS.ERROR:
			return {
				...state,
				slrError: action.error,
				slrBookingDetails: null,
			}
		case SLR_BOOKING_DETAILS.CLEAR:
			return initState
		case SLR_BOOKING_RESULT.SET:
			return {
				...state,
				resultData: action.resultData,
			}
		case SLR_BOOKING_RESULT.CLEAR:
			return {
				...state,
				resultData: null,
			}
		default:
			return state
	}
}
